//#region src/client_type.ts
var ClientType = /* @__PURE__ */ function(ClientType) {
	ClientType[ClientType["KioskPreview"] = 0] = "KioskPreview";
	ClientType[ClientType["Kiosk"] = 1] = "Kiosk";
	ClientType[ClientType["Flash"] = 2] = "Flash";
	return ClientType;
}(ClientType || {});
//#endregion
export { ClientType };

//# sourceMappingURL=client_type.js.map